export default {
	"pages": {
		"root": {
			"id": "root",
			"pageUrl": "root",
			"name": "root",
			"children": [
				"63fce114aed6310020bc6cce",
				"63fce114aed6310020bc6cd1"
			]
		},
		"63fce114aed6310020bc6cce": {
			"id": "63fce114aed6310020bc6cce",
			"name": "404",
			"pageUrl": "404"
		},
		"63fce114aed6310020bc6cd1": {
			"id": "63fce114aed6310020bc6cd1",
			"name": "index",
			"pageUrl": "index"
		}
	},
	"mode": "production",
	"projectType": "create-react-app",
	"site": {
		"styles": {},
		"seo": {}
	}
}